import { read } from "./read"

export const corporationAccount = {
  read,
}
